import { Stack, Theme } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import { ReactElement, ReactNode } from "react";

/**
 * Page Header
 * Could include title, subtitle, actions, filters, etc.
 */
export type FullPageContainerHeaderProps = {
  children: ReactNode;
  sx?: SxProps<Theme>;
};

export function FullPageContainerHeader({
  children,
  sx,
}: FullPageContainerHeaderProps): ReactElement {
  return (
    <Stack
      sx={[
        { mb: 4, transition: (theme) => theme.transitions.create("width") },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Stack>
  );
}

FullPageContainerHeader.displayName = "FullPageContainerHeader";
